class ChromaColor {
    constructor(options) {
        this.opts = Object.assign({
            sceneSelector: '.is-color .el-color-szene',
            headerSelector: '.header',
            headerScrollY: 100,
            colors: ['#22272a', '#6B0AFA', '#E3143A', '#FA830A', '#000000']
        }, options || {});

        // ALLE Szenen holen
        this.scenes = document.querySelectorAll(this.opts.sceneSelector);
        this.header = document.querySelector(this.opts.headerSelector);

        this.reduceMotion = !!(window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches);

        this.scale = null;
        this.maxScroll = 1;
        this.ticking = false;

        this.init();
    }

    init() {
        var self = this;

        // Wenn keine Szene existiert → nur Header-Scroll-Status
        if (!this.scenes || !this.scenes.length) {
            window.addEventListener('scroll', function () {
                self.toggleHeader(window.pageYOffset || 0);
            });
            return;
        }

        this.recalc();

        window.addEventListener('scroll', function () {
            self.onScroll();
        });

        window.addEventListener('resize', function () {
            self.recalc();
            self.update();
        });

        this.update();
    }

    recalc() {
        this.maxScroll = (document.documentElement.scrollHeight || 1) - window.innerHeight;
        if (this.maxScroll < 1) this.maxScroll = 1;

        if (typeof window.chroma === 'undefined') {
            this.scale = null;
            return;
        }

        this.scale = window.chroma
            .scale(this.opts.colors)
            .domain([0, this.maxScroll]);
    }

    onScroll() {
        var self = this;

        if (!this.ticking) {
            this.ticking = true;
            requestAnimationFrame(function () {
                self.update();
            });
        }
    }

    clampY(y) {
        var clamped = y;
        if (clamped < 0) clamped = 0;
        if (clamped > this.maxScroll) clamped = this.maxScroll;
        return clamped;
    }

    update() {
        var y = window.pageYOffset || 0;

        this.toggleHeader(y);

        if (!this.reduceMotion && this.scale && this.scenes && this.scenes.length) {
            var clamped = this.clampY(y);
            var color = this.scale(clamped).css();

            // auf ALLE Szenen anwenden
            this.scenes.forEach(function (el) {
                el.style.backgroundColor = color;
            });
        }

        this.ticking = false;
    }

    toggleHeader(scrollY) {
        if (!this.header) return;

        if (scrollY > this.opts.headerScrollY) {
            this.header.classList.add('scroll');
        } else {
            this.header.classList.remove('scroll');
        }
    }
}